import axios from 'axios';

// API Utils
// export const baseUrl = "http://localhost:8000/api/";
// export const mediaUrl = "http://localhost:8000/storage/uploads/";
export const baseUrl = "https://fleetproserver.fleetassist.in/public/api/";
export const mediaUrl = "https://fleetproserver.fleetassist.in/public/storage/uploads/";


export const uploadFile = async (image: File) => {
    const token = localStorage.getItem("token");
    if (!token) throw new Error("Unauthorized: Token not found");

    const formdata = new FormData();
    formdata.append("image", image);

    try {
        const file_response = await axios.post(`${baseUrl}fileupload`, formdata, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });
        return file_response.data.filename;
    } catch (error: any) {
        console.error("File upload failed:", error.response || error.message);
        throw error;
    }
};

export const apiGet = async (endpoint: string) => {
    const token = localStorage.getItem('token');
    const response = await axios.get(`${baseUrl}${endpoint}`, {
        headers: {
            Authorization: `Bearer ${token}`,
        },
    });
    return response.data;
};

export const apiPost = async (endpoint: string, body: any = {}) => {
    const token = localStorage.getItem('token');
    const response = await axios.post(`${baseUrl}${endpoint}`, body, {
        headers: {
            Authorization: `Bearer ${token}`,
        },
    });
    return response.data;
};

//dynamic image
const images = require.context(`/public/assets/images`, true);

export const dynamicImage = (image: string | undefined) => {
    return images(`./${image}`);
};

//dynamic Number
export function dynamicNumber(totalLength: number) {
    return Array.from({ length: totalLength }, (_, index) => index + 1);
};